import React, {PropTypes} from 'react';
import CalendarPrices from '../containers/CalendarPrices';

class Prices extends React.Component {

  constructor () {
    super();
  }

  render() {
    // Define which area has been clicked
    let areas = this.props.data;
    let areaId = this.props.selection.infobox_area_id;

    // Define which to_cities are concerned here, and what are the prices to get there
    let to_city_ids;
    let all_prices = this.props.prices.prices;
    let prices;
    let prices_calendars = [];
    let prices_empty_state = '';
    let key;
    let from_country_code = this.props.userLocation.country_code_2;
    let from_city_name = this.props.userLocation.from_city_name;
    let currency_code = this.props.userLocation.currency_code;

    // Can be undefined when infobox is closed, causing a crash
    if(areaId){
      let country_code = areas[areaId]['country_code'];

      // This is now an array of 3 cities
      to_city_ids = areas[areaId]['city_ids'];

      // For each city
      for (let i=0; i<to_city_ids.length; i++){
        // The prices are conveniently ordered by to_city_id
        prices = all_prices[to_city_ids[i]];
        key = areaId + '-' + to_city_ids[i];

        // Prices can be undefined when some new cities have not been computed on s3
        if(prices){
          prices_calendars.push(
            <div key={key}>
              <CalendarPrices
                prices={prices}
                isFetching={this.props.prices.isFetching}
                initialWidth={this.props.initialWidth}
              />
            </div>
          );
        }
      }

      // empty state
      // Fancy keys method on a hash http://stackoverflow.com/questions/5223/length-of-a-javascript-object
      if(Object.keys(to_city_ids).length === 0) {
        prices_empty_state = (
          <div className="empty_state">
            No prices available.
          </div>
        );
      }

      // Skyscanner link
      // https://support.business.skyscanner.net/hc/en-us/articles/211237109-Referrals
      let link = 'http://partners.api.skyscanner.net/apiservices/referral/v1.0/FR/' + currency_code + '/en-'+from_country_code+'/'+from_country_code+'/'+country_code+'/anytime?apiKey=cl93269575589318';

      return (
        <div className="prices-container">
          <div className="prices-container-calendar">
            {prices_calendars}
            {prices_empty_state}
          </div>
          <div className="row prices-container-links">
            <div className="col-sm-6">
              <div className="title">
                <p>
                  Prices in <a data-toggle="modal" data-target="#currency" href="#currency">{currency_code}</a>, starting from <a data-toggle="modal" data-target="#location" href="#location">{from_city_name}</a>.
                </p>
              </div>
            </div>
            <div className="col-sm-6 skyscanner-button-container">
              <p>
                <a href={link} target="_blank" className="skyscanner-button">View flights on Skyscanner</a>
              </p>
            </div>
          </div>
        </div>
      );
    }
    else{
      return(false);
    }
  }
}

Prices.propTypes = {
  data: PropTypes.object.isRequired,
  prices: PropTypes.object.isRequired,
  selection: PropTypes.object.isRequired,
  userLocation: PropTypes.object.isRequired,
  currencies: PropTypes.object.isRequired,
  initialWidth: PropTypes.string.isRequired
};

export default Prices;



/** WEBPACK FOOTER **
 ** ./src/components/Prices.js
 **/